var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oph-details absolute inset-0 bg-black"},[(_vm.svg)?_c('div',{staticClass:"svg s-fill",domProps:{"innerHTML":_vm._s(_vm.svg)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }